document.addEventListener("DOMContentLoaded", function () {
  if (window.__popupPromotionsInit) return
  window.__popupPromotionsInit = true

  const popup = document.querySelector(".subscribe-popup")
  if (!popup) return

  const overlay = popup.querySelector(".subscribe-popup__overlay")
  const closeBtn = popup.querySelector(".subscribe-popup-box-close")

  function dismiss() {
    popup.classList.remove("active")
    sessionStorage.setItem("subscribe-popup", "true")
  }

  if (overlay) {
    overlay.addEventListener("click", function (e) {
      if (e.target.classList.contains("subscribe-popup__overlay")) {
        dismiss()
      }
    })
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      dismiss()
    })
  }

  if (location.search.indexOf("customer_posted=true") !== -1 && location.hash === "#subscribePopup") {
    sessionStorage.setItem("subscribe-popup", "true")
    popup.classList.add("active")
    return
  }

  const dismissed = sessionStorage.getItem("subscribe-popup")
  const autoShow = popup.dataset.autoShow !== "false"
  if (!autoShow || dismissed) return

  let started = false
  window.addEventListener("scroll", function () {
    if (started) return
    started = true
    if (popup.classList.contains("active")) return
    const timeout = popup.dataset.delay
    setTimeout(function () {
      if (sessionStorage.getItem("subscribe-popup")) return
      popup.classList.add("active")
    }, timeout)
  })
})
